export enum EntityClassTypes {
  PERSON = 'Person',
  PRODUCT = 'Product'
}

export class IABase {
  id: number
  videoEntityId: number
  interactiveAreaId: number
  name: string
  entityId: number
  entityClass: EntityClassTypes
  zIndex?: number
}
export class InteractiveArea extends IABase {
  shots: number[]
  events: number[]

  constructor (interactiveArea: InteractiveArea) {
    super()
    for (const property in interactiveArea) {
      this[property] = interactiveArea[property]
    }
  }
}
